import tw, { styled } from "twin.macro";
import { BgColor } from 'styles/basic/BgColor';

const InputBase = styled(BgColor).attrs((props) => ({
    className: props.width ? `w-${props.width}` : 'w-full',
    color: props.color || 'card',
}))`
    && {
        ${tw`inline-flex items-center leading-6 text-color-normal focus:outline-none`}

        ${({ size }) => (size === 'small' ? tw`px-0 py-0` : tw`px-4 py-3`)}
        ${({ noStyle }) =>
            !noStyle &&
            tw`border border-gray-300 focus:(border-gray-400 ring-primary ring-1 ring-opacity-50)`}
        ${({ noStyle, start }) => !noStyle && !start && tw`rounded-l`}
        ${({ noStyle, end }) => !noStyle && !end && tw`rounded-r`}
        ${({ error }) => error && tw`border-error bg-error-light focus:(bg-paper border-error ring-error ring-1 ring-opacity-50)`}
        ${({ clickable }) => clickable && tw`cursor-pointer hocus:bg-paper`}
        ${({ disabled }) => disabled && tw`text-color-disabled`}
    }
`;

export const InputStart = styled(InputBase).attrs({ end: 'end' })``;

export const InputEnd = styled(InputBase).attrs({ start: 'start' })``;

export const InputIcon = ({ icon }) => styled(icon)`
    ${tw`w-8 h-8`}
`;

export default InputBase;